import { publicApiInstance } from 'api/internaltools';

export const initiateTotp = async () => {
  return publicApiInstance.post('/v1/b2b-user/initiate-totp');
};

export const validateTotp = async (payload) => {
  return publicApiInstance.post('/v1/b2b-user/validate-totp-setup', payload);
};
